import { useEffect, useState } from "react";
import { SELECT_ALL_KEY } from "globals/constants";

export const useSelectedRows = ({ rows, getRowKey }) => {
	const [ selectedRows, setSelectedRows ] = useState(new Map());
	const [ isSelectAll, setIsSelectAllInternal ] = useState(false);

	const setRowSelection = (row, isSelected) => {
		const isSelectAll = row === SELECT_ALL_KEY;

		if (isSelectAll) {
			setIsSelectAllInternal(isSelected);
		} else {
			const updatedSelections = new Map(selectedRows);
			const rowKey = getRowKey(row); //row._item?.id;
			const shouldAdd = isSelected && !updatedSelections.has(rowKey);

			shouldAdd
				? updatedSelections.set(rowKey, row)
				: updatedSelections.delete(rowKey);

			setSelectedRows(updatedSelections);
		}
	};

	const clearSelections = () => {
		setIsSelectAllInternal(false);
		setSelectedRows(new Map());
	};

	useEffect(() => {
		const updatedSelections = isSelectAll
			? new Map(rows.map(row => [ getRowKey(row), row ]))
			: new Map();

		setSelectedRows(updatedSelections);
	}, [ isSelectAll, getRowKey ]);

	return {
		selectedRows,
		isSelectAll,
		setRowSelection,
		clearSelections,
	};
};

export default useSelectedRows;
